import ModalAcept from './ModalAcept';

export default ModalAcept;
